import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"error-page-inner bg_color--4"},[_c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('div',{staticClass:"inner"},[_c('h1',[_vm._v("404!")]),_c('h3',[_vm._v(_vm._s(_vm.$t('pageNotFound.title')))]),_c('span',[_vm._v(_vm._s(_vm.$t('pageNotFound.subtitle')))]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('pageNotFound.button')))])],1)])])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }